import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

/** The `?dice-library` inspection table — a developer tool, loaded only on that URL. */
const DiceBox = lazy(() => import('./components/DiceBox.tsx'));
import './styles.css';
import './tabletop.css';
// D-EZ-102 — the story screens. After the tabletop theme, whose tokens it reads.
import './story.css';
// D-EZ-104/105 — the stakes card and the commissioner's table.
import './stakes.css';
// D-EZ-109 — the weekly Wire.
import './wire.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {new URLSearchParams(window.location.search).has('dice-library') ? (
      <Suspense fallback={null}>
        <DiceBox />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
);
